import React, {Component} from "react";
import {Link} from "react-router-dom";

class Banner extends Component {
	render() {
		const {img_en, leagues} = this.props.item;
		const banner_link = `/line-leagues/${leagues.join('-')}`;

		return (
			<Link to={banner_link} className="banners__banner hockey">
				<img src={`http://maxline.by/assets/images/banner/${img_en}`}/>
			</Link>
		);
	}
}

export default Banner;


// WEBPACK FOOTER //
// ./src/app/components/Banner.js